<template>
  <div :class="color_fts">
    {{ parachute_fts }}
  </div>
</template>

<script>

export default {
  props: {
    config: Object
  },
  computed: {
    parachute_fts() {
      let status = this.config?.parachute?.status?.fts_state != undefined
        ? this.config.parachute.status.fts_state
        : -1;

      if (status == 1) {
        return this.$e("Allumé");
      }
      else if (status == 0) {
        return this.$e("Éteint");
      }
      else {
        return this.$e("Inconnu");
      }
    },

    color_fts() {
      let status = this.config?.parachute?.status?.fts_state != undefined
        ? this.config.parachute.status.fts_state
        : -1;

      if (status == 1) {
        return "text-success";
      }
      else if (status == 0) {
        return "text-error";
      }
      else {
        return "text-warning";
      }
    }
  },
};
</script>
